module.exports = __webpack_public_path__ + "img/logo-footer.5ac1b0fd.jpeg";